import defaultImage from '../../../public/img/package.svg'

const loadImageBundles = {
  methods: {
    imageBundleOrProductLoading(bundle) {
      if (!bundle.image) {
        return defaultImage
      }
      return bundle.image
    },
  },
}

export default loadImageBundles
